import { MethodPropertyModifySettingsForm } from "components/Forms/MethodPropertyModifySettingForm/MethodPropertyModifySettingsForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { RequestConnectionPropertyType } from "types/enums";
import { DrawerId } from "types/models.ts";

import FormFieldData = App.Data.FormFieldData;
import ResponseConnectionPropertyData = App.Data.ResponseConnectionPropertyData;

interface MethodPropertyBodySettingDrawerProps {
    name: number;
    parentName: number;
    propertyType: RequestConnectionPropertyType;
    leadFields?: Array<FormFieldData | ResponseConnectionPropertyData>;
}

export const MethodPropertyBodySettingDrawer: FC<MethodPropertyBodySettingDrawerProps> = ({
    name,
    parentName,
    propertyType,
    leadFields,
}) => {
    const { t } = usePaldockTranslation("drawers.method-request-body-setting");
    const drawerId = DrawerId.MethodPropertyBodySetting;

    const propertyPath = `methods.${parentName}.requestConfig.requestConnectionProperties.${name}` as const;

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title", { name })} />}
            searchParamsToClean={[`${drawerId}-id`, `${drawerId}-propertyType`, `${drawerId}-parentName`]}
        >
            <MethodPropertyModifySettingsForm
                leadFields={leadFields}
                propertyType={propertyType}
                propertyPath={propertyPath}
            />
        </Drawer>
    );
};
